import { isAxiosError } from 'axios'

export const GRAFANA_MONITOR_SEARCH_FIELD_WIDTH = 400
const MAX_RETRY_ATTEMPTS = 3

/**
 * Determine whether the Grafana monitor search query should retry failed/errored requests.
 */
export function getRetryPredicateFn(retryCount: number, error: unknown) {
  if (retryCount >= MAX_RETRY_ATTEMPTS || !isAxiosError(error)) return false

  const errorCode = error.code ? parseInt(error.code) ?? 0 : 0

  return errorCode >= 500 || error.response?.data?.status !== 'ERROR'
}
